import { dynamicAPI } from '../services/api';

/** Keep only cards for requested slugs, in footer link order. */
export function orderUpcomingTrekCardsBySlugs(rows, slugs) {
  const list = (slugs || []).map((s) => String(s).trim().toLowerCase()).filter(Boolean);
  if (!list.length) return rows || [];
  const slugSet = new Set(list);
  const order = new Map(list.map((s, i) => [s, i]));
  return (rows || [])
    .filter((r) => slugSet.has(String(r.trek?.slug || '').trim().toLowerCase()))
    .sort(
      (a, b) =>
        (order.get(String(a.trek?.slug || '').trim().toLowerCase()) ?? 999) -
        (order.get(String(b.trek?.slug || '').trim().toLowerCase()) ?? 999)
    );
}

/**
 * Load upcoming trek cards for footer ?treks= links.
 * Uses bulk API first, then resolves any missing slugs against the trek catalog.
 */
export async function loadUpcomingTreksBySlugs(slugs) {
  const list = (slugs || []).map((s) => String(s).trim().toLowerCase()).filter(Boolean);
  if (!list.length) return [];

  const key = list.join(',');
  const response = await dynamicAPI.getUpcomingTreks({
    treks: key,
    slugs: key,
    limit: Math.max(200, list.length * 3)
  });
  let rows = orderUpcomingTrekCardsBySlugs(response.data?.data || [], list);

  if (rows.length >= list.length) return rows;

  const returned = new Set(rows.map((r) => String(r.trek?.slug || '').trim().toLowerCase()));
  const missing = list.filter((s) => !returned.has(s));
  if (!missing.length) return rows;

  try {
    const trekRes = await dynamicAPI.getTreks({ page: 1, limit: 500, isActive: true });
    const allTreks = trekRes.data?.data || [];

    for (const miss of missing) {
      const hit = allTreks.find((t) => {
        const s = String(t.slug || '').trim().toLowerCase();
        return s === miss || s.startsWith(`${miss}-`) || miss.startsWith(`${s}-`);
      });
      if (!hit?.slug) continue;
      const slug = String(hit.slug).trim().toLowerCase();
      if (returned.has(slug)) continue;
      const extra = await dynamicAPI.getUpcomingTreks({ slugs: slug, treks: slug, limit: 5 });
      const card = orderUpcomingTrekCardsBySlugs(extra.data?.data || [], [slug])[0];
      if (card) {
        rows.push(card);
        returned.add(slug);
      }
    }
  } catch {
    // return partial matches
  }

  return orderUpcomingTrekCardsBySlugs(rows, list);
}
